(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-tab-block"] && !Shopify.designMode) return;
  try {
    
    class BrandsTab extends HTMLElement {
        constructor() {
            super();
            this.tabTitle = this.querySelector('.tab-title');
            this.tabContent = this.querySelector('.tab-panel-content');
            const ele = this.querySelectorAll('[tab-title-action]');
            const actionLoadMore = this.querySelectorAll('[data-load-more-block]');
            this.widthWindow = 0;
            if (ele.length) {
                ele.forEach((button) => button.addEventListener('click', this.onActive.bind(this)));
            }
            if (actionLoadMore.length) {
                actionLoadMore.forEach((button) => button.addEventListener('click', this.onLoadMore.bind(this)));
            }
        }

        onActive(e) {
            this.tabTitle.querySelector('.active').classList.remove('active');
            this.tabContent.querySelector('.active').classList.remove('active');
            this.querySelector(e.target.dataset.target).classList.add('active');
            e.target.parentElement.classList.add('active');
        }
        onLoadMore(e) {
            this.resize();
            if (this.widthWindow > 1024) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-lg');
                var _number = e.target.dataset.rowlg;
                var _class = 'hidden-lg';
                
            } else if(this.widthWindow > 551) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-md');
                var _number = 9;
                var _class = 'hidden-md';
            } else {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-sm');
                var _number = 6;
                var _class = 'hidden-sm';
            }
            if (eleHide.length) {
                // let number_show = (eleHide.length > number ? number : eleHide.length);
                if (e.target.classList.contains('more')) {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.remove('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonmore;
                    e.target.classList.remove('more');
                } else {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.add('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonless;
                    e.target.classList.add('more');
                }

                // (eleHide.length > _number ? '' : e.target.classList.add('hidden'));
            }
        }
        resize() {
            this.widthWindow = window.innerWidth;
        }
    }
    customElements.define('brand-tab', BrandsTab);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-mobile"]) return;
  try {
    
    class StickyHeaderMobile extends HTMLElement {
        constructor() {
            super();
        }
  
        connectedCallback() {
            this.header = document.querySelector('.section-header-mobile');
            this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
            this.headerBounds = {};
    
            if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
            };
    
            this.currentScrollTop = 0;
            this.preventReveal = false;
            this.predictiveSearch = this.querySelector('predictive-search');
    
            this.onScrollHandler = this.onScroll.bind(this);
            this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    
            this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.addEventListener('scroll', this.onScrollHandler, false);
    
            this.createObserver();
        }
  
        disconnectedCallback() {
            this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.removeEventListener('scroll', this.onScrollHandler);
        }
  
        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });
    
            observer.observe(this.header);
        }
  
        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
            if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    
            if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (this.preventHide) return;
                requestAnimationFrame(this.hide.bind(this));
            } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (!this.preventReveal) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else {
                    window.clearTimeout(this.isScrolling);
        
                    this.isScrolling = setTimeout(() => {
                    this.preventReveal = false;
                    }, 66);
        
                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop <= this.headerBounds.top) {
                this.header.classList.remove('scrolled-past-header');
                requestAnimationFrame(this.reset.bind(this));
            }
    
            this.currentScrollTop = scrollTop;
        }
  
        hide() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            this.header.style.top = '';
        }
  
        reveal() {
            const headerMultiSite = document.querySelector('.section-header-nav-multi-site');
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            if (headerMultiSite) {
                const height = headerMultiSite.offsetHeight;
                this.header.style.top = `${height}px`;
            }
        }
  
        reset() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            this.header.style.top = '';
        }
    }
  
    customElements.define('sticky-header-mobile', StickyHeaderMobile);

    document.querySelector('[data-mobile-menu]').addEventListener('click', () => {
        document.body.classList.toggle('menu_open');
    })

    function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        const expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    };

    function renderLogoMobile() {
        if ($("[data-menu-tab]").length > 0) {

            $(document).on("click", "[data-menu-tab] li", (event) => {
                var active = $(event.currentTarget).data("load-page"),
                    href = $(event.currentTarget).attr("href");

                setCookie("page-url", active, {
                    expires: 1,
                    path: "/",
                });
            });

            var canonical = $("[canonical-shop-url]").attr("canonical-shop-url"),
            pageUrl = setCookie("page-url"),
            menuTabItem,
            logoTabItem,
            menuItem;

            if (
                window.location.pathname.indexOf("/pages/") !== -1 &&
                window.page_active &&
                window.page_active != pageUrl
            ) {
                setCookie("page-url", window.page_active, 1);
                pageUrl = window.page_active;
            }
            if (pageUrl != null) {
                menuTabItem = $(`[data-load-page="${pageUrl}"]`);
                logoTabItem = $(`[data-load-logo-page="${pageUrl}"]`);
                menuItem = $(`[data-load-menu-page="${pageUrl}"]`);
            } else {
                menuTabItem = $("[data-load-page].is-active");
                logoTabItem = $("[data-load-logo-page].first");
                menuItem = $("[data-load-menu-page].is-active");
            }

            var menuTab = menuTabItem.closest("[data-menu-tab]");

            menuTab
                .find("[data-load-page]")
                .not(menuTabItem)
                .removeClass("is-active");
                logoTabItem.siblings().removeClass("is-active");
                menuItem.siblings().removeClass("is-active");
            if (pageUrl != "") {
                logoTabItem.addClass("is-active");
                menuTabItem.addClass("is-active");
                menuItem.addClass("is-active");
            } else {
                $("[data-load-page]:nth-child(1)").addClass("is-active");
                $("[data-load-logo-page]:nth-child(1)").addClass("is-active");
                $("[data-load-menu-page]:nth-child(1)").addClass("is-active");
            }

            const header = menuTabItem.closest(".header");

            
            if (header && window.innerWidth < 1025) {
                if (
                    window.location.pathname.indexOf("/pages/") !== -1 &&
                    window.page_active &&
                    window.page_active != pageUrl
                ) {
                    setCookie("page-url", window.page_active, 1);
                    pageUrl = window.page_active;
                }

                const logoMobile = $(".header-mobile .header__heading-link");
                const logDesktop = header.find(".header__heading-link.is-active");

                if (logDesktop.data("logo-mobile") == undefined) {
                    logoMobile.find("img").addClass("logo-show");
                    return;
                } else {
                    logoMobile.html(
                    `<img src="${logDesktop.data(
                        "logo-mobile"
                    )}" alt="${logDesktop.data(
                        "logo-mobile-alt"
                    )}" style="max-width: ${logoMobile.data(
                        "logo-width"
                    )}px; height: auto"/>`
                    );

                    logoMobile.find("img").addClass("logo-show");
                    if (pageUrl != "" && pageUrl != null)
                    logoMobile.attr("href", pageUrl);
                }
            }
        }
    }

    renderLogoMobile();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-nav-multi-site"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-multi-site');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
          this.headerBounds = {};
          this.setHeaderHeight();
          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };
          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;
          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);
          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });
          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);
              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);
              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }
          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    document.addEventListener('DOMContentLoaded', () => {customElements.define('sticky-header', StickyHeader)});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-basic"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-basic');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-compact"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-compact');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-full-elements"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-full-elements');
if (sticky != undefined || sticky != null) {
    console.log("sticky full: " + sticky)

    class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header-navigation');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-hamburger"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-hamburger');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
          this.headerBounds = {};
          this.setHeaderHeight();
          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };
          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;
          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('load', this.checkLoadPosition.bind(this));
          window.addEventListener('scroll', this.onScrollHandler, false);
          this.createObserver();
        }
        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }
        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('load', this.checkLoadPosition);
          window.removeEventListener('scroll', this.onScrollHandler);
        }
        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });
          observer.observe(this.header);
        }
        checkLoadPosition() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const headerGr = document.querySelectorAll(".shopify-section-group-header-group");

            if(headerGr[0].classList.contains('shopify-section-header-sticky')) {
                if(scrollTop > headerGr[0].offsetHeight && !this.header.classList.contains('scrolled-past-header')) {
                    this.header.classList.add('shopify-section-header-hidden');
                }
            } else {
                headerGr.forEach(item => {
                    if(item.classList.contains('shopify-section-header-sticky') ) {
                        const itemPrev = item.previousElementSibling;
                        const itemPrevHeight = itemPrev.offsetHeight;
                        const itemPrevTop = itemPrev.offsetTop;

                        if(scrollTop > itemPrevTop + itemPrevHeight && !this.header.classList.contains('scrolled-past-header')) {
                            this.header.classList.add('shopify-section-header-hidden');
                        }
                    }
                });
            }
        }
        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);
              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }
          this.currentScrollTop = scrollTop;
        }
        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                    document.querySelector('body').classList.add("section-header-is-hidden")
                }
            }
          this.closeMenuDisclosure();
        }
        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
                  document.querySelector('body').classList.remove("section-header-is-hidden")
              }
            }
        }
        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
                  document.querySelector('body').classList.remove("section-header-is-hidden")
              }
            }
        }
        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-left-aligned"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-left-aligned');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-plain"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-plain');

if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header-navigation');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-utility"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-utility');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-vertical-menu"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-vertical-menu');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
                if(!$('.vertical-menu').hasClass('vertical-menu__style_3')){
                    $('.vertical-menu').addClass('vertical-menu__hide');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
              if(!$('.vertical-menu').hasClass('vertical-menu__style_3')){
                  if (document.body.classList.contains('template-index')) {
                      if ($('.vertical-menu').hasClass('vertical-menu__hide')) {
                          $('.vertical-menu').removeClass('vertical-menu__hide');
                      }
                  }
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ra-cart"]) return;
  try {
    
(() => {
  const initialize = (root) => {
    const form = root.querySelector('[data-ra-cart-form]');
    if (!form || root.dataset.initialized || !window.fetch || !window.FormData || !window.DOMParser) return;
    root.dataset.initialized = 'true';
    const labels = root.querySelector('[data-ra-cart-labels]').dataset;
    const fields = Array.from(form.querySelectorAll('[data-ra-quantity]'));
    const updateButton = root.querySelector('[data-ra-cart-update]');
    const checkoutButton = root.querySelector('[data-ra-checkout]');
    const error = root.querySelector('[data-ra-cart-error]');
    const status = root.querySelector('[data-ra-cart-status]');
    const mobileAccess = root.querySelector('[data-ra-mobile-access]');
    const sectionId = root.dataset.sectionId;
    const initial = fields.map((field) => ({ key: field.dataset.lineKey, quantity: Number(field.dataset.originalQuantity) }));
    let busy = false;
    let uncertain = false;
    const isDirty = () => fields.some((field) => !field.hasAttribute('data-retired-line') && Number(field.value) !== Number(field.dataset.originalQuantity));
    const validQuantity = (quantity, minimum, maximum, step) => Number.isSafeInteger(quantity) && quantity >= minimum && (maximum === null || quantity <= maximum) && quantity % step === 0;
    const syncDirty = () => {
      const dirty = isDirty();
      root.querySelectorAll('[data-ra-confirmed-total],[data-ra-mobile-price]').forEach((node) => { node.hidden = dirty || uncertain; });
      root.querySelectorAll('[data-ra-dirty],[data-ra-mobile-pending]').forEach((node) => { node.hidden = !dirty && !uncertain; });
      checkoutButton.disabled = busy || dirty || uncertain || root.dataset.retired === 'true';
      root.querySelectorAll('[data-ra-offer-button]').forEach((button) => { button.disabled = busy || dirty || uncertain || root.dataset.retired === 'true'; });
      mobileAccess.textContent = dirty || uncertain ? labels.mobileUpdate : labels.mobileAction;
      mobileAccess.href = '#' + (dirty || uncertain ? 'RAUpdate-' : 'RACartSummary-') + sectionId;
    };
    const announce = (message, isError) => {
      const target = isError ? error : status;
      if (isError) error.querySelector('[data-ra-cart-error-text]').textContent = message;
      else status.textContent = message;
      target.hidden = false;
      target.focus();
    };
    const notifyCount = (count) => {
      if (Number.isFinite(count)) document.querySelectorAll('[data-ra-cart-count]').forEach((node) => { node.textContent = String(count); });
      document.dispatchEvent(new CustomEvent('ra:cart-changed'));
    };
    const render = (markup, message, isError) => {
      if (typeof markup !== 'string') throw new Error(labels.uncertain);
      const next = new DOMParser().parseFromString(markup, 'text/html').querySelector('[data-ra-cart]');
      if (!next) throw new Error(labels.uncertain);
      root.replaceWith(next);
      initialize(next);
      const feedback = next.querySelector(isError ? '[data-ra-cart-error]' : '[data-ra-cart-status]');
      if (isError) feedback.querySelector('[data-ra-cart-error-text]').textContent = message;
      else feedback.textContent = message;
      feedback.hidden = false;
      feedback.focus();
      notifyCount(Number(next.dataset.cartCount));
    };
    const refresh = async (message, isError) => {
      const url = new URL(labels.cartUrl, window.location.origin);
      url.searchParams.set('section_id', sectionId);
      const response = await fetch(url, { headers: { Accept: 'text/html' }, cache: 'no-store' });
      if (!response.ok) throw new Error(labels.uncertain);
      render(await response.text(), message, isError);
    };
    fields.forEach((field) => field.addEventListener('input', syncDirty));
    root.addEventListener('click', (event) => {
      if (busy && event.target.closest('a,button')) event.preventDefault();
    });
    root.addEventListener('submit', async (event) => {
      const submitted = event.target;
      if (submitted !== form && !submitted.matches('[data-ra-offer-form]')) return;
      if (busy) { event.preventDefault(); return; }
      if (submitted === form && event.submitter && event.submitter.name === 'checkout') {
        if (isDirty() || uncertain || root.dataset.retired === 'true' || !form.reportValidity()) {
          event.preventDefault();
          announce(labels.dirty, true);
          return;
        }
        event.preventDefault();
        busy = true;
        root.dataset.busy = 'true';
        syncDirty();
        try {
          const response = await fetch(labels.readUrl, {headers:{Accept:'application/json'},cache:'no-store'});
          if (!response.ok) throw new Error(labels.uncertain);
          const current = await response.json();
          const stale = !Array.isArray(current.items) || current.total_price !== Number(root.dataset.cartTotal) || current.items.length !== initial.length || initial.some(old => !current.items.some(line => line.key === old.key && line.quantity === old.quantity));
          if (stale) {await refresh(labels.stale, true); return;}
          const intent = document.createElement('input');
          intent.type = 'hidden'; intent.name = 'checkout'; intent.value = '1'; form.append(intent);
          document.dispatchEvent(new CustomEvent('ra:checkout', {detail:{cart:current,source:'cart'}}));
          HTMLFormElement.prototype.submit.call(form);
        } catch {
          busy = false; uncertain = true;
          root.dataset.busy = 'false';
          syncDirty();
          announce(labels.uncertain, true);
        }
        return;
      }
      event.preventDefault();
      if (uncertain) { announce(labels.uncertain, true); return; }
      let changes;
      if (submitted.matches('[data-ra-offer-form]')) {
        if (isDirty() || root.dataset.retired === 'true') { announce(labels.dirty, true); return; }
        const quantity = Number(submitted.dataset.offerQuantity);
        const maximum = submitted.dataset.max === '' ? null : Number(submitted.dataset.max);
        if (!validQuantity(quantity, Number(submitted.dataset.min), maximum, Number(submitted.dataset.step))) { announce(labels.invalid, true); return; }
        changes = [{ key: submitted.dataset.lineKey, quantity }];
      } else {
        if (!form.reportValidity()) return;
        changes = fields.filter((field) => Number(field.value) !== Number(field.dataset.originalQuantity)).map((field) => ({ key: field.dataset.lineKey, quantity: Number(field.value), field }));
        for (const change of changes) {
          if (change.field.hasAttribute('data-retired-line') && change.quantity === 0) continue;
          const maximum = change.field.max === '' ? null : Number(change.field.max);
          if (!validQuantity(change.quantity, Number(change.field.min), maximum, Number(change.field.step))) { announce(labels.invalid, true); return; }
        }
      }
      if (changes.length === 0) { announce(labels.updated, false); return; }
      busy = true;
      root.dataset.busy = 'true';
      root.setAttribute('aria-busy', 'true');
      error.hidden = true;
      status.hidden = false;
      status.textContent = labels.updating;
      const controls = Array.from(root.querySelectorAll('button,input'));
      const disabledStates = controls.map((control) => control.disabled);
      controls.forEach((control) => { control.disabled = true; });
      updateButton.textContent = labels.updating;
      let message = labels.error;
      try {
        const currentResponse = await fetch(labels.readUrl, { headers: { Accept: 'application/json' }, cache: 'no-store' });
        if (!currentResponse.ok) throw new Error(labels.error);
        let current = await currentResponse.json();
        if (!Array.isArray(current.items)) throw new Error(labels.error);
        const stale = current.total_price !== Number(root.dataset.cartTotal) || current.items.length !== initial.length || initial.some((old) => !current.items.some((line) => line.key === old.key && line.quantity === old.quantity));
        if (stale) { await refresh(labels.stale, true); return; }
        for (const change of changes) {
          if (!current.items.some((line) => line.key === change.key)) { message = labels.stale; throw new Error(message); }
          const response = await fetch(labels.changeUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: change.key, quantity: change.quantity, sections: [sectionId], sections_url: labels.cartUrl })
          });
          const result = await response.json();
          if (!response.ok) {
            message = typeof result.description === 'string' ? result.description : labels.error;
            throw new Error(message);
          }
          if (!Array.isArray(result.items)) throw new Error(labels.uncertain);
          current = result;
        }
        const markup = current.sections && current.sections[sectionId];
        if (typeof markup === 'string') render(markup, labels.updated, false);
        else await refresh(labels.updated, false);
        document.dispatchEvent(new CustomEvent('ra:cart-updated', {detail:{cart:current,source:'cart'}}));
      } catch (problem) {
        try {
          await refresh(message, true);
        } catch (refreshError) {
          busy = false;
          uncertain = true;
          root.dataset.busy = 'false';
          root.removeAttribute('aria-busy');
          controls.forEach((control, index) => { control.disabled = disabledStates[index]; });
          updateButton.textContent = labels.update;
          syncDirty();
          announce(labels.uncertain, true);
          document.dispatchEvent(new CustomEvent('ra:cart-changed'));
        }
      }
    });
    syncDirty();
  };
  const init = (scope = document) => scope.querySelectorAll('[data-ra-cart]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ra-catalog"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normalize = (value) => value.toLocaleLowerCase('ro').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
    const initialize = (root) => {
      if (root.dataset.raReady) return;
      const controls = root.querySelector('[data-ra-controls]');
      const query = root.querySelector('[data-ra-query]');
      const sort = root.querySelector('[data-ra-sort]');
      const grid = root.querySelector('[data-ra-grid]');
      const result = root.querySelector('[data-ra-results]');
      const reset = root.querySelector('[data-ra-reset]');
      const empty = root.querySelector('[data-ra-empty]');
      const chips = Array.from(root.querySelectorAll('[data-ra-category]'));
      const items = Array.from(root.querySelectorAll('[data-ra-item]'));
      if (!controls || !query || !sort || !grid || !result || !reset || !empty) return;
      root.dataset.raReady = 'true';
      let category = 'all';
      const params = new URL(window.location.href).searchParams;
      const requestedCategory = params.get('ra_category');
      if (chips.some((chip) => chip.dataset.raCategory === requestedCategory)) category = requestedCategory;
      query.value = params.get('ra_q') || '';
      const requestedSort = params.get('ra_sort');
      if (Array.from(sort.options).some((option) => option.value === requestedSort)) sort.value = requestedSort;
      const update = (syncUrl) => {
        const term = normalize(query.value);
        const terms = term.split(/\s+/).filter(Boolean);
        let count = 0;
        const ordered = items.slice().sort((first, second) => {
          if (sort.value === 'title-asc') return first.dataset.raTitle.localeCompare(second.dataset.raTitle, 'ro');
          if (sort.value === 'price-asc') return Number(first.dataset.raPrice) - Number(second.dataset.raPrice);
          if (sort.value === 'price-desc') return Number(second.dataset.raPrice) - Number(first.dataset.raPrice);
          return Number(first.dataset.raPosition) - Number(second.dataset.raPosition);
        });
        ordered.forEach((item) => {
          const searchable = normalize(item.dataset.raTitle);
          const visible = (category === 'all' || item.dataset.raProductCategory === category) && terms.every((part) => searchable.includes(part));
          item.hidden = !visible;
          if (visible) count += 1;
          grid.appendChild(item);
        });
        chips.forEach((chip) => chip.setAttribute('aria-pressed', String(chip.dataset.raCategory === category)));
        result.textContent = count === 1 ? result.dataset.raCountOne : result.dataset.raCountMany.replace('[count]', String(count));
        empty.hidden = count !== 0;
        reset.hidden = category === 'all' && term === '' && sort.value === 'default';
        if (syncUrl) {
          const url = new URL(window.location.href);
          category === 'all' ? url.searchParams.delete('ra_category') : url.searchParams.set('ra_category', category);
          term === '' ? url.searchParams.delete('ra_q') : url.searchParams.set('ra_q', query.value.trim());
          sort.value === 'default' ? url.searchParams.delete('ra_sort') : url.searchParams.set('ra_sort', sort.value);
          window.history.replaceState(window.history.state, '', url);
        }
      };
      query.addEventListener('input', () => update(true));
      sort.addEventListener('change', () => update(true));
      chips.forEach((chip) => chip.addEventListener('click', () => { category = chip.dataset.raCategory; update(true); }));
      reset.addEventListener('click', () => { category = 'all'; query.value = ''; sort.value = 'default'; update(true); query.focus(); });
      controls.hidden = false;
      update(false);
    };
    const initializeAll = (scope) => scope.querySelectorAll('[data-ra-catalog]').forEach(initialize);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll(document));
    else initializeAll(document);
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ra-commerce"]) return;
  try {
    
(() => {
  const root = document.querySelector('[data-ra-commerce]');
  if (!root || root.dataset.initialized || !window.fetch || !window.HTMLDialogElement) return;
  root.dataset.initialized = 'true';
  const revealQuick = () => document.querySelectorAll('[data-ra-quick-view]').forEach(button => {button.hidden = false;});
  revealQuick();
  document.addEventListener('shopify:section:load', revealQuick);
  const labels = root.dataset;
  const quick = root.querySelector('[data-ra-quick-dialog]');
  const drawer = root.querySelector('[data-ra-cart-dialog]');
  const quickContent = root.querySelector('[data-ra-quick-content]');
  const panelContent = root.querySelector('[data-ra-panel-content]');
  const quickStatus = root.querySelector('[data-ra-quick-status]');
  const panelStatus = root.querySelector('[data-ra-panel-status]');
  const money = new Intl.NumberFormat(labels.locale || 'ro-RO', {style:'currency',currency:labels.currency || 'RON'});
  const format = value => money.format(value / 100);
  let trigger = null;
  let requestSerial = 0;
  let busy = false;
  let panelUncertain = true;
  const announce = (element, message, error = false) => {element.textContent = message; element.setAttribute('role', error ? 'alert' : 'status');};
  const show = (dialog, opener) => {
    if (opener) trigger = opener;
    [quick,drawer].forEach(other => {if (other !== dialog && other.open) other.close();});
    if (!dialog.open) dialog.showModal();
    dialog.querySelector('[data-ra-dialog-close]').focus();
  };
  [quick,drawer].forEach(dialog => {
    dialog.addEventListener('click', event => {if (event.target === dialog || event.target.closest('[data-ra-dialog-close]')) dialog.close();});
    dialog.addEventListener('close', () => {requestSerial++; if (!quick.open && !drawer.open && trigger?.isConnected) trigger.focus({preventScroll:true});});
  });
  const request = async (url, options) => {
    const response = await fetch(url, options);
    if (!response.ok) throw new Error(labels.error);
    return response;
  };
  const loadSection = async (path, section, selector) => {
    const url = new URL(path, location.origin);
    url.searchParams.set('section_id', section);
    const response = await request(url, {headers:{Accept:'text/html'},cache:'no-store'});
    const element = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector(selector);
    if (!element) throw new Error(labels.error);
    return element;
  };
  const panel = () => panelContent.querySelector('[data-ra-cart-panel]');
  const dirty = () => Array.from(panelContent.querySelectorAll('[data-ra-panel-line]')).some(line => Number(line.querySelector('input').value) !== Number(line.dataset.quantity));
  const syncPanel = () => {
    const current = panel();
    if (!current) return;
    const invalid = dirty() || panelUncertain || busy;
    const checkout = current.querySelector('[data-ra-panel-checkout]');
    if (checkout) checkout.disabled = invalid || current.dataset.retired === 'true';
    const confirmed = current.querySelector('[data-ra-panel-confirmed]');
    if (confirmed) confirmed.hidden = dirty() || panelUncertain;
    const warning = current.querySelector('[data-ra-panel-dirty]');
    if (warning) warning.hidden = !dirty() && !panelUncertain;
  };
  const updateCount = count => document.querySelectorAll('[data-ra-cart-count]').forEach(node => {node.textContent = String(count);});
  const refreshPanel = async () => {
    const next = await loadSection(labels.cartUrl, 'ra-cart-panel', '[data-ra-cart-panel]');
    panelContent.replaceChildren(next);
    panelUncertain = false;
    root.querySelector('[data-ra-panel-fallback]').hidden = true;
    updateCount(next.dataset.count);
    syncPanel();
    return next;
  };
  const openCart = async opener => {
    if (busy) return;
    show(drawer, opener);
    panelContent.replaceChildren();
    panelUncertain = true;
    root.querySelector('[data-ra-panel-fallback]').hidden = false;
    announce(panelStatus, labels.loading);
    try {await refreshPanel(); announce(panelStatus, '');}
    catch {announce(panelStatus, labels.uncertain, true);}
  };
  const initializeQuick = product => {
    const form = product.querySelector('form');
    const variant = product.querySelector('[data-ra-quick-variant]');
    const quantity = product.querySelector('[data-ra-quick-quantity]');
    const plans = product.querySelector('[data-ra-quick-plans]');
    const add = product.querySelector('[data-ra-quick-add]');
    const error = product.querySelector('[data-ra-quick-error]');
    const selectedPlan = () => {const select = plans.querySelector('[data-ra-plan]'); return select?.value ? select.selectedOptions[0] : null;};
    const planReady = () => plans.querySelector('[data-ra-purchase]').dataset.required !== 'true' || Boolean(selectedPlan());
    const available = () => variant.selectedOptions[0].dataset.available === 'true';
    const sync = () => {
      const option = variant.selectedOptions[0];
      const plan = selectedPlan();
      const valid = quantity.checkValidity() && Number.isSafeInteger(Number(quantity.value));
      add.disabled = busy || !available() || !planReady() || !valid;
      add.textContent = busy ? labels.adding : !available() ? labels.unavailable : !planReady() ? labels.choosePlan : labels.add;
      product.querySelector('[data-ra-quick-price]').textContent = format(plan ? Number(plan.dataset.deliveryAmount) : Number(option.dataset.price));
      product.querySelector('[data-ra-quick-total-label]').textContent = plan ? labels.chargeLabel : labels.totalLabel;
      const count = Number(quantity.value);
      const quantityOffer = product.dataset.quantityOffer === 'true' && !plan;
      const rate = quantityOffer ? (count >= 3 ? 0.85 : count >= 2 ? 0.90 : 1) : 1;
      const charge = plan ? Number(plan.dataset.checkoutAmount) : Number(option.dataset.price);
      product.querySelector('[data-ra-quick-total]').textContent = !planReady() ? labels.choosePlan : !valid ? labels.invalid : format(Math.round(charge * rate) * count);
      const volumeNote = product.querySelector('[data-ra-quick-volume-note]');
      if (volumeNote) volumeNote.hidden = Boolean(plan);
      plans.querySelectorAll('[data-ra-plan-detail]').forEach(detail => {detail.hidden = detail.dataset.raPlanDetail !== plan?.value;});
      const prompt = plans.querySelector('[data-ra-plan-prompt]');
      if (prompt) prompt.hidden = planReady();
    };
    variant.addEventListener('change', () => {
      const oldPlan = selectedPlan()?.value;
      plans.replaceChildren(product.querySelector(`[data-ra-quick-template="${variant.value}"]`).content.cloneNode(true));
      const select = plans.querySelector('[data-ra-plan]');
      if (oldPlan && select && Array.from(select.options).some(option => option.value === oldPlan)) select.value = oldPlan;
      const option = variant.selectedOptions[0];
      quantity.min = option.dataset.min; quantity.step = option.dataset.step;
      if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
      if (!quantity.checkValidity()) quantity.value = option.dataset.min;
      error.hidden = true; sync();
    });
    form.addEventListener('input', sync);
    form.addEventListener('change', sync);
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || !available() || !planReady() || !form.reportValidity()) return;
      const data = new FormData(form);
      if (!selectedPlan()) data.delete('selling_plan');
      const controls = Array.from(form.querySelectorAll('button,input,select'));
      const states = controls.map(control => control.disabled);
      busy = true; error.hidden = true;
      controls.forEach(control => {control.disabled = true;}); sync();
      let message = labels.error;
      try {
        const response = await fetch(labels.addUrl, {method:'POST',body:data,headers:{Accept:'application/json'}});
        const result = await response.json();
        if (!response.ok) {message = typeof result.description === 'string' ? result.description : message; throw new Error(message);}
        document.dispatchEvent(new CustomEvent('ra:cart-changed', {detail:{variantId:variant.value,sellingPlanId:data.get('selling_plan') || null,source:'quick'}}));
        document.dispatchEvent(new CustomEvent('ra:cart-updated', {detail:{source:'quick'}}));
        busy = false;
        await openCart();
        if (panel()) announce(panelStatus, labels.added);
      } catch {error.textContent = message; error.hidden = false; error.focus();}
      finally {busy = false; controls.forEach((control,index) => {control.disabled = states[index];}); sync();}
    });
    sync();
  };
  document.addEventListener('click', async event => {
    const cartButton = event.target.closest('[data-ra-open-cart]');
    if (cartButton && !event.ctrlKey && !event.metaKey && !event.shiftKey) {event.preventDefault(); await openCart(cartButton); return;}
    const button = event.target.closest('[data-ra-quick-view]');
    if (!button || busy) return;
    event.preventDefault();
    const url = new URL(button.dataset.raQuickView, location.origin);
    if (url.origin !== location.origin) return;
    show(quick, button);
    const serial = ++requestSerial;
    quickContent.replaceChildren();
    const fallback = root.querySelector('[data-ra-quick-fallback]');
    fallback.href = url.pathname + url.search; fallback.hidden = false;
    announce(quickStatus, labels.loading);
    try {
      const next = await loadSection(url, 'ra-quick-product', '[data-ra-quick-product]');
      if (serial !== requestSerial || !quick.open) return;
      quickContent.replaceChildren(next); initializeQuick(next); fallback.hidden = true; announce(quickStatus, '');
    } catch {if (serial === requestSerial) announce(quickStatus, labels.error, true);}
  });
  panelContent.addEventListener('input', syncPanel);
  const readCart = async () => (await request(labels.readUrl, {headers:{Accept:'application/json'},cache:'no-store'})).json();
  const matchesPanel = current => {
    const snapshot = panel();
    const lines = Array.from(snapshot.querySelectorAll('[data-ra-panel-line]'));
    return Array.isArray(current.items) && current.total_price === Number(snapshot.dataset.total) && current.items.length === lines.length && lines.every(line => current.items.some(item => item.key === line.dataset.key && item.quantity === Number(line.dataset.quantity)));
  };
  const changePanel = async (removeKey, checkout) => {
    if (busy || !panel() || panelUncertain) return;
    const form = panel().querySelector('form');
    if (!form || !form.reportValidity()) return;
    if (checkout && (dirty() || panel().dataset.retired === 'true')) return;
    const changes = Array.from(panel().querySelectorAll('[data-ra-panel-line]')).map(line => ({id:line.dataset.key,quantity:line.dataset.key === removeKey ? 0 : Number(line.querySelector('input').value),previous:Number(line.dataset.quantity)})).filter(change => change.quantity !== change.previous);
    busy = true; syncPanel();
    const controls = Array.from(form.querySelectorAll('button,input'));
    const states = controls.map(control => control.disabled);
    controls.forEach(control => {control.disabled = true;});
    announce(panelStatus, labels.loading);
    let message = labels.error;
    try {
      const current = await readCart();
      if (!matchesPanel(current)) {await refreshPanel(); announce(panelStatus, labels.stale, true); return;}
      if (checkout) {
        controls.forEach((control,index) => {control.disabled = states[index];});
        const input = document.createElement('input'); input.type = 'hidden'; input.name = 'checkout'; input.value = '1'; form.append(input);
        document.dispatchEvent(new CustomEvent('ra:checkout', {detail:{cart:current,source:'drawer'}}));
        HTMLFormElement.prototype.submit.call(form);
        return;
      }
      for (const change of changes) {
        const response = await fetch(labels.changeUrl, {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:change.id,quantity:change.quantity})});
        const result = await response.json();
        if (!response.ok) {message = typeof result.description === 'string' ? result.description : message; throw new Error(message);}
      }
      await refreshPanel(); announce(panelStatus, labels.updated);
      document.dispatchEvent(new CustomEvent('ra:cart-changed', {detail:{source:'drawer'}}));
      if (changes.length) document.dispatchEvent(new CustomEvent('ra:cart-updated', {detail:{source:'drawer'}}));
    } catch {
      try {await refreshPanel(); announce(panelStatus, message, true);}
      catch {panelUncertain = true; announce(panelStatus, labels.uncertain, true); root.querySelector('[data-ra-panel-fallback]').hidden = false;}
    } finally {
      busy = false;
      controls.forEach((control,index) => {control.disabled = states[index];});
      syncPanel();
      if (drawer.open) panelStatus.focus();
    }
  };
  panelContent.addEventListener('submit', event => {event.preventDefault(); changePanel(null, event.submitter?.name === 'checkout');});
  panelContent.addEventListener('click', event => {const button = event.target.closest('[data-ra-panel-remove]'); if (button) changePanel(button.closest('[data-ra-panel-line]').dataset.key, false);});
  document.addEventListener('ra:cart-added', () => openCart(document.activeElement));
  document.addEventListener('ra:cart-changed', event => {
    if (!drawer.open || event.detail?.source === 'drawer' || event.detail?.source === 'quick') return;
    panelUncertain = true; syncPanel();
    if (!busy) refreshPanel().catch(() => announce(panelStatus, labels.uncertain, true));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ra-editorial"]) return;
  try {
    
  (() => {
    const initEditorial = (scope = document) => {
      scope.querySelectorAll('[data-editorial]').forEach((root) => {
        if (root.dataset.editorialReady) return;
        root.dataset.editorialReady = 'true';
        const filters = root.querySelector('[data-editorial-filters]');
        if (filters) {
          const cards = Array.from(root.querySelectorAll('[data-editorial-list] [data-editorial-card]'));
          const buttons = Array.from(filters.querySelectorAll('[data-editorial-filter]'));
          const status = filters.querySelector('[data-editorial-status]');
          const empty = root.querySelector('[data-editorial-filter-empty]');
          const filter = (category) => {
            let count = 0;
            cards.forEach((card) => {
              card.hidden = Boolean(category && card.dataset.category !== category);
              if (!card.hidden) count += 1;
            });
            buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.editorialFilter === category)));
            if (status) status.textContent = status.dataset.message.replace('__COUNT__', String(count));
            if (empty) empty.hidden = count > 0;
          };
          buttons.forEach((button) => button.addEventListener('click', () => filter(button.dataset.editorialFilter)));
          root.querySelector('[data-editorial-reset]')?.addEventListener('click', () => { filter(''); buttons[0]?.focus(); });
          filter('');
          filters.hidden = false;
        }
        const body = root.querySelector('[data-editorial-body]');
        if (!body) return;
        body.querySelectorAll('table').forEach((table) => {
          if (table.parentElement.classList.contains('ra-editorial__table-scroll')) return;
          const wrapper = document.createElement('div');
          wrapper.className = 'ra-editorial__table-scroll';
          wrapper.tabIndex = 0;
          wrapper.setAttribute('role', 'region');
          wrapper.setAttribute('aria-label', body.dataset.tableLabel);
          table.before(wrapper);
          wrapper.append(table);
        });
        const toc = root.querySelector('[data-editorial-toc]');
        const list = root.querySelector('[data-editorial-toc-list]');
        const headings = Array.from(body.querySelectorAll('h2, h3')).filter((heading) => heading.textContent.trim() && !heading.closest('[hidden]'));
        if (!toc || !list || headings.length < 2) return;
        const ids = new Set(Array.from(document.querySelectorAll('[id]'), (node) => node.id));
        headings.forEach((heading, index) => {
          if (!heading.id || document.getElementById(heading.id) !== heading) {
            const base = `article-${root.dataset.sectionId}-${index + 1}`;
            let candidate = base;
            let suffix = 1;
            while (ids.has(candidate)) candidate = `${base}-${suffix++}`;
            heading.id = candidate;
            ids.add(candidate);
          }
          heading.tabIndex = -1;
          const item = document.createElement('li');
          if (heading.tagName === 'H3') item.className = 'ra-editorial__toc-sub';
          const anchor = document.createElement('a');
          anchor.href = `#${encodeURIComponent(heading.id)}`;
          anchor.textContent = heading.textContent.trim();
          anchor.addEventListener('click', () => heading.focus({ preventScroll: true }));
          item.append(anchor);
          list.append(item);
        });
        toc.hidden = false;
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initEditorial());
    else initEditorial();
    document.addEventListener('shopify:section:load', (event) => initEditorial(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ra-footer"] && !Shopify.designMode) return;
  try {
    
if (!window.raCookiePreferencesReady) {
  window.raCookiePreferencesReady = true;
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-ra-cookie-preferences]');
    if (!button || button.disabled) return;
    const footer = button.closest('footer');
    const status = footer.querySelector('[data-ra-cookie-status]');
    const fallback = footer.querySelector('[data-ra-cookie-fallback]');
    button.disabled = true;
    status.textContent = '';
    fallback.hidden = true;
    try {
      if (typeof window.privacyBanner?.showPreferences !== 'function') throw new Error('unavailable');
      await window.privacyBanner.showPreferences();
    } catch (error) {
      status.textContent = button.dataset.error;
      fallback.hidden = false;
    } finally {
      button.disabled = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ra-header"]) return;
  try {
    
  document.addEventListener('ra:cart-changed',async()=>{const header=document.querySelector('[data-ra-cart-url]');if(!header)return;try{const response=await fetch(header.dataset.raCartUrl,{headers:{Accept:'application/json'}});if(!response.ok)return;const cart=await response.json();document.querySelectorAll('[data-ra-cart-count]').forEach(el=>el.textContent=String(cart.item_count))}catch(e){}});
  if(!customElements.get('ra-search'))customElements.define('ra-search',class extends HTMLElement{
    connectedCallback(){this.input=this.querySelector('input[type=search]');this.box=this.querySelector('[id=RaPredictions]');this.status=this.querySelector('[data-search-status]');this.active=-1;this.input.addEventListener('input',()=>{clearTimeout(this.timer);this.controller?.abort();this.close();const q=this.input.value.trim();if(q.length<2)return;this.timer=setTimeout(()=>this.load(q),220)});this.input.addEventListener('keydown',e=>this.key(e));this.addEventListener('focusout',()=>setTimeout(()=>{if(!this.contains(document.activeElement))this.close()},0));this.querySelector('form').addEventListener('submit',()=>{this.controller?.abort();this.close()});this.outside=e=>{if(!this.contains(e.target))this.close()};document.addEventListener('pointerdown',this.outside)}
    disconnectedCallback(){clearTimeout(this.timer);this.controller?.abort();document.removeEventListener('pointerdown',this.outside)}
    close(){this.box.hidden=true;this.input.setAttribute('aria-expanded','false');this.input.removeAttribute('aria-activedescendant');this.active=-1}
    async load(q){this.controller=new AbortController();const u=new URL(this.dataset.url,location.origin);u.searchParams.set('q',q);u.searchParams.set('resources[type]','product');u.searchParams.set('resources[limit]','5');u.searchParams.set('resources[options][fields]','title,variants.title,variants.sku');u.searchParams.set('section_id','ra-predictive-search');try{const r=await fetch(u,{signal:this.controller.signal});if(!r.ok)throw new Error();const doc=new DOMParser().parseFromString(await r.text(),'text/html');const el=doc.querySelector('[data-ra-predictions]');if(!el||q!==this.input.value.trim())return;this.box.replaceChildren(el);this.box.hidden=false;this.input.setAttribute('aria-expanded','true');this.status.textContent=el.dataset.resultText||''}catch(e){if(e.name!=='AbortError')this.close()}}
    key(e){if(e.key==='Escape'){this.close();return}const opts=[...this.box.querySelectorAll('[role=option]')];if(this.box.hidden||!opts.length)return;if(e.key==='ArrowDown'||e.key==='ArrowUp'){e.preventDefault();this.active=this.active<0?(e.key==='ArrowDown'?0:opts.length-1):(this.active+(e.key==='ArrowDown'?1:-1)+opts.length)%opts.length;opts.forEach((o,i)=>o.setAttribute('aria-selected',String(i===this.active)));this.input.setAttribute('aria-activedescendant',opts[this.active].id);opts[this.active].scrollIntoView({block:'nearest'})}else if(e.key==='Enter'&&this.active>=0){e.preventDefault();opts[this.active].querySelector('a').click()}}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ra-product"]) return;
  try {
    
(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-ra-product]').forEach((root) => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const form = root.querySelector('form');
      const selector = root.querySelector('[data-ra-variant]');
      const quantity = root.querySelector('[data-ra-quantity]');
      const button = root.querySelector('[data-ra-add]');
      const error = root.querySelector('[data-ra-error]');
      const success = root.querySelector('[data-ra-success]');
      const labels = root.querySelector('[data-ra-labels]').dataset;
      const purchaseBox = root.querySelector('[data-ra-purchase-options]');
      const presets = root.querySelector('[data-ra-quantity-presets]');
      const sticky = root.querySelector('[data-ra-sticky]');
      const totalBox = root.querySelector('[data-ra-total-box]');
      const totalNote = root.querySelector('[data-ra-total-note]');
      const money = new Intl.NumberFormat(labels.locale || 'ro-RO', {style: 'currency', currency: labels.currency || 'RON', currencyDisplay: 'narrowSymbol'});
      const format = (cents) => money.format(cents / 100);
      const variantOption = () => selector.selectedOptions[0];
      const purchase = () => purchaseBox.querySelector('[data-ra-purchase]');
      const planSelector = () => purchaseBox.querySelector('[data-ra-plan]');
      const planOption = () => {
        const select = planSelector();
        return select && select.value ? select.selectedOptions[0] : null;
      };
      const needsPlan = () => purchase().dataset.required === 'true';
      const validPlan = () => !needsPlan() || Boolean(planOption());
      const hasEligiblePlans = () => Number(purchase().dataset.count) > 0;
      const validQuantity = (value) => {
        const min = Number(quantity.min) || 1;
        const step = Number(quantity.step) || 1;
        return Number.isSafeInteger(value) && value >= min && (!quantity.max || value <= Number(quantity.max)) && (value - min) % step === 0;
      };
      const clearFeedback = () => {error.hidden = true; success.hidden = true;};
      const syncURL = () => {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', selector.value);
        const plan = planOption();
        if (plan) url.searchParams.set('selling_plan', plan.value);
        else url.searchParams.delete('selling_plan');
        window.history.replaceState({}, '', url);
      };
      const refresh = () => {
        const option = variantOption();
        const plan = planOption();
        const available = option.dataset.available === 'true';
        const ready = validPlan();
        const count = Number(quantity.value);
        const volumeRate = (n) => labels.quantityOffer === 'true' && !plan ? (n >= 3 ? 0.85 : n >= 2 ? 0.90 : 1) : 1;
        const volumeNote = root.querySelector('[data-ra-volume-note]');
        if (volumeNote) volumeNote.hidden = Boolean(plan);
        const quantityOK = validQuantity(count);
        const busy = form.dataset.busy === 'true';
        const price = root.querySelector('[data-ra-price]');
        const priceLabel = root.querySelector('[data-ra-price-label]');
        price.textContent = plan ? plan.dataset.price : option.dataset.price;
        priceLabel.textContent = plan ? labels.deliveryPrice : needsPlan() ? labels.referencePrice : labels.unitPrice;
        root.querySelector('[data-ra-availability]').textContent = available ? labels.available : labels.unavailable;
        button.disabled = busy || !available || !ready;
        const accelerated = root.querySelector('[data-ra-accelerated]');
        if (accelerated) accelerated.hidden = busy || !available || !ready || !quantityOK;
        button.textContent = busy ? labels.adding : !available ? labels.unavailable : !ready ? hasEligiblePlans() ? labels.choosePlan : labels.unavailable : labels.add;
        purchaseBox.querySelectorAll('[data-ra-plan-detail]').forEach((detail) => {detail.hidden = !plan || detail.dataset.raPlanDetail !== plan.value;});
        const prompt = purchaseBox.querySelector('[data-ra-plan-prompt]');
        if (prompt) prompt.hidden = ready;
        if (presets) {
          presets.hidden = false;
          presets.querySelector('legend').textContent = plan ? labels.bottlesPlan : labels.bottles;
          presets.querySelectorAll('[data-ra-quantity-choice]').forEach((choice) => {
            const value = Number(choice.dataset.raQuantityChoice);
            choice.disabled = busy || !available || !validQuantity(value);
            choice.setAttribute('aria-pressed', String(value === count));
            const offerPrice = choice.querySelector('[data-ra-volume-price]');
            if (offerPrice) {
              offerPrice.hidden = Boolean(plan);
              offerPrice.textContent = `${format(Math.round(Number(option.dataset.priceAmount) * volumeRate(value)) * value)}${value > 1 ? ` · −${value === 2 ? 10 : 15}%` : ''}`;
            }
          });
        }
        const total = root.querySelector('[data-ra-total]');
        const totalLabel = root.querySelector('[data-ra-total-label]');
        const charge = plan ? Number(plan.dataset.checkoutAmount) : Number(option.dataset.priceAmount);
        const selectionTotal = Math.round(charge * volumeRate(count)) * count;
        totalLabel.textContent = plan ? labels.totalPlan : labels.total;
        total.textContent = !ready ? hasEligiblePlans() ? labels.choosePlan : labels.noPlan : quantityOK && Number.isFinite(charge) ? format(selectionTotal) : labels.invalidQuantity;
        totalBox.hidden = false;
        totalNote.hidden = !ready || !quantityOK;
        sticky.querySelector('[data-ra-sticky-total]').textContent = ready && quantityOK && Number.isFinite(charge) ? format(selectionTotal) : '—';
        sticky.querySelector('[data-ra-sticky-label]').textContent = !available ? labels.unavailable : !ready ? hasEligiblePlans() ? labels.choosePlan : labels.noPlan : !quantityOK ? labels.invalidQuantity : plan ? labels.totalPlan : labels.total;
      };
      const updateVariant = () => {
        const previousPlan = planOption()?.value;
        const option = variantOption();
        const template = root.querySelector(`[data-ra-purchase-template="${selector.value}"]`);
        if (template) purchaseBox.replaceChildren(template.content.cloneNode(true));
        const select = planSelector();
        if (previousPlan && select && Array.from(select.options).some((candidate) => candidate.value === previousPlan)) select.value = previousPlan;
        quantity.min = option.dataset.min;
        quantity.step = option.dataset.step;
        if (option.dataset.max) quantity.max = option.dataset.max;
        else quantity.removeAttribute('max');
        if (!validQuantity(Number(quantity.value))) quantity.value = option.dataset.min;
        clearFeedback();
        refresh();
        syncURL();
        const photo = root.querySelector(`[id$="-${option.dataset.image}"]`);
        if (photo) root.querySelector('.ra-product__gallery').scrollLeft = photo.offsetLeft - photo.parentElement.offsetLeft;
      };
      selector.addEventListener('change', updateVariant);
      purchaseBox.addEventListener('change', () => {clearFeedback(); refresh(); syncURL();});
      quantity.addEventListener('input', () => {clearFeedback(); refresh();});
      if (presets) presets.addEventListener('click', (event) => {
        const choice = event.target.closest('[data-ra-quantity-choice]');
        if (!choice || choice.disabled) return;
        quantity.value = choice.dataset.raQuantityChoice;
        clearFeedback();
        refresh();
      });
      sticky.querySelector('[data-ra-purchase-access]').addEventListener('click', (event) => {
        event.preventDefault();
        let target = form;
        if (form.dataset.busy !== 'true') {
          if (!validPlan()) target = planSelector() || form;
          else if (variantOption().dataset.available !== 'true') target = selector.closest('[hidden]') ? form : selector;
          else if (!quantity.checkValidity()) target = quantity;
          else target = button;
        }
        target.scrollIntoView({block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        target.focus({preventScroll: true});
      });
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(([entry]) => {sticky.hidden = entry.isIntersecting && entry.intersectionRatio >= 0.8;}, {threshold: [0, 0.8], rootMargin: '0px 0px -90px 0px'});
        observer.observe(root.querySelector('[data-ra-purchase-target]'));
        document.addEventListener('shopify:section:unload', (event) => {if (event.target.contains(root)) observer.disconnect();}, {once: true});
      }
      refresh();
      syncURL();
      form.addEventListener('submit', async (event) => {
        if (form.dataset.busy === 'true') {event.preventDefault(); return;}
        if (variantOption().dataset.available !== 'true' || !validPlan()) {
          event.preventDefault();
          error.textContent = !validPlan() ? hasEligiblePlans() ? labels.choosePlan : labels.noPlan : labels.unavailable;
          error.hidden = false;
          (planSelector() || error).focus();
          return;
        }
        if (!form.reportValidity()) {event.preventDefault(); return;}
        if (event.submitter && event.submitter !== button) {
          document.dispatchEvent(new CustomEvent('ra:checkout', {detail:{source:'product'}}));
          return;
        }
        if (!window.fetch || !window.FormData) return;
        event.preventDefault();
        const data = new FormData(form);
        const submittedVariant = selector.value;
        const submittedPlan = planOption()?.value || null;
        if (!submittedPlan) data.delete('selling_plan');
        const controls = Array.from(form.querySelectorAll('input, select, button'));
        const states = controls.map((control) => control.disabled);
        form.dataset.busy = 'true';
        form.setAttribute('aria-busy', 'true');
        controls.forEach((control) => {control.disabled = true;});
        clearFeedback();
        refresh();
        let message = labels.error;
        try {
          const response = await fetch(labels.cartAdd, {method: 'POST', body: data, headers: {Accept: 'application/json'}});
          const result = await response.json();
          if (!response.ok) {message = typeof result.description === 'string' ? result.description : labels.error; throw new Error(message);}
          success.hidden = false;
          document.dispatchEvent(new CustomEvent('ra:cart-changed', {detail: {variantId: submittedVariant, sellingPlanId: submittedPlan}}));
          success.querySelector('a').focus({preventScroll: true});
          document.dispatchEvent(new CustomEvent('ra:cart-updated', {detail:{source:'product'}}));
          document.dispatchEvent(new CustomEvent('ra:cart-added'));
        } catch (problem) {
          error.textContent = message;
          error.hidden = false;
          error.focus();
        } finally {
          form.dataset.busy = 'false';
          form.removeAttribute('aria-busy');
          controls.forEach((control, index) => {control.disabled = states[index];});
          refresh();
        }
      });
    });
  };
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
